<template>
    <fragment>
        <v-dialog
        v-model="this.$appMng.showNews"
        width="600px"
        >
        <v-card>
            <v-card-title>
                <span class="headline">{{this.$appMng.titleNews}}</span>
            </v-card-title>
            <v-card-text>
                <p></p>
                <div v-html="this.$appMng.contentNews"></div>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="green darken-1"
                    text
                    @click="confirmView"
                >
                    Estou ciente
                </v-btn>
            </v-card-actions>
        </v-card>
        </v-dialog>
    </fragment>

</template>

<script>
import {updateUserViewedNews} from "../../../api/api-news";

export default {
  name: "DialogNews",
  components: {
  },
  data() {
    return {
      isLoading: false,        
    }
  },  
  methods: {  
    onClose() {
      this.$appMng.setShowNews(false)
    },
    confirmView() {
      if (this.$appMng.idNews > 0) {
        let data_send = {
            "cd_mappa_updates": this.$appMng.idNews
        }
        
        updateUserViewedNews(this.$apiAuth.getAuthToken(), data_send)
        .then(() => {
            console.log('Marcou a novidade como lida com sucesso para o usuário') 
            this.$appMng.setShowNews(false)         
        })
        .catch(() => {
            console.log('Não conseguiu marcar a novidade como lida para o usuário') 
            this.$appMng.setShowNews(false)
        }) 
      } else {
        this.$appMng.setShowNews(false)
      }
    } 
  },
  mounted () {   
  },
  computed: {
    title() {
        return this.$appMng.titleNews
    },
    content() {
        return this.$appMng.contentNews
    },
    active() {
        return this.$appMng.showNews
    }               
  },  
}
</script>

<style scoped>

  .itemDialogClass .md-dialog-container {
      width: 75vw;
  }

  .overflow-div {
    overflow-x: auto;
    overflow-y: auto;
  }

  .close-display-topright{
    position: absolute;
    right:0;
    top:0;
    min-width: 45px !important;
    width: 45px !important;
    height: 35px !important;
    font-size: 35px !important;
  }

  .md-dialog {
    border-radius: 10px !important;
  }

  .parent {position: relative;}

  .child {
      position: absolute;
      top: 45%;
      left: 30%;
      height: 30%;
      width: 50%;
      margin: -15% 0 0 -25%;
  }

  .row-filter {
    margin-bottom: 30px !important;
  }

  .titulo {
    margin-bottom: 40px !important;
    margin-top: 30px !important;
  }

  .icon-confirmation {
    min-height: 40px !important;
    height: 60px !important;
    width: 60px !important;
    min-width: 40px !important;
  }

</style>
